import React from 'react';
import {
  StructureLeftRightWrapper,
  LevelOneInfoStyled,
  LevelOneInfoVolume,
  LevelZeroTopInfo
} from '../../../../MyTeamBackofficeStyled';

import { useSelector } from 'react-redux';
import { DotLineArrows, UserVerifications } from '../../../common';
import { RootTeamMemberInfo } from '../../../../common';
import { getIsLegsWeaker, getLegStregthsS } from '../../../../utils';
import { BV, formatVP } from '../../../../../../helpers/helperFunctions';
import { useTranslation } from 'react-i18next';
import { CaptionText } from '../../../../../../styles/FontStyles';
import { color } from '../../../../../../styles/GlobalStyles';

export const ZeroLevelInfo = ({ isOpen, teamMember }) => {
  const { t } = useTranslation('myTeam');

  const [leftLegStrenght, rightLegStrength] = getLegStregthsS(teamMember);
  const [isLeftLegWeaker, isRightLegWeaker] = getIsLegsWeaker(teamMember);

  return (
    <LevelOneInfoStyled open={isOpen}>
      <UserVerifications teamMember={teamMember} />

      <LevelZeroTopInfo>
        <RootTeamMemberInfo />
      </LevelZeroTopInfo>

      <DotLineArrows />
      <StructureLeftRightWrapper>
        <div>
          <h1>{t('left_team')}</h1>
          {leftLegStrenght}
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>Commissionable Volume</h1>

              <h2>
                {/* {formatVP(teamMember?.leftLegInfo?.legTotalVolume)} {BV} */}
                {0} {BV}
              </h2>

              {teamMember?.todayLeftLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(0)}{' '}
                    {/* +{formatVP(teamMember?.todayLeftLegTotalVolume)}{' '} */}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>{t('total_downline')}</h1>
              <h2>{teamMember?.leftLegInfo?.totalDownline}</h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{formatVP(0)}{' '}
                  {/* +{teamMember?.leftLegInfo?.todayTotalDownline}{' '} */}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isLeftLegWeaker}>
            <div>
              <h1>{t('total_directs')}</h1>
              <h2>
                {/* {teamMember?.leftLegInfo?.todayTotalDirectUsersCount} */}
                {0}
              </h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{formatVP(0)}{' '}
                  {/* +{teamMember?.leftLegInfo?.todayTotalDownline}{' '} */}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
        </div>
        <div>
          <h1>{t('right_team')}</h1>
          {rightLegStrength}
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>Commissionable Volume</h1>
              <h2>
                {/* {formatVP(teamMember?.rightLegInfo?.legTotalVolume)} {BV} */}
                {0} {BV}
              </h2>
              {teamMember?.todayRightLegTotalVolume >= 0 && (
                <h1>
                  <span
                    style={{
                      color: color.colors.primary900
                    }}>
                    +{formatVP(0)}{' '}
                    {/* +{formatVP(teamMember?.todayRightLegTotalVolume)}{' '} */}
                  </span>
                  {t('today')}
                </h1>
              )}
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>{t('total_downline')}</h1>
              <h2>{teamMember?.rightLegInfo?.totalDownline}</h2>

              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{formatVP(0)}{' '}
                  {/* +{teamMember?.rightLegInfo?.todayTotalDownline}{' '} */}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
          <LevelOneInfoVolume weaker={isRightLegWeaker}>
            <div>
              <h1>{t('total_directs')}</h1>
              <h2>
                {/* {teamMember?.rightLegInfo?.totalDirectUsersCount} */}
                {0}
              </h2>
              <h1>
                <span
                  style={{
                    color: color.colors.primary900
                  }}>
                  +{formatVP(0)}{' '}
                  {/* +{teamMember?.leftLegInfo?.todayTotalDirectUsersCount}{' '} */}
                </span>
                {t('today')}
              </h1>
            </div>
          </LevelOneInfoVolume>
        </div>
      </StructureLeftRightWrapper>
    </LevelOneInfoStyled>
  );
};
